import { SMLRouteParts, SMLRoutes } from '../../../routing/sml/SMLRoutes';
import { SMLSettingsTabId } from './types';

export interface SettingsTabTarget {
  route: SMLRouteParts;
  params?: Record<string, string>;
}

/**
 * The address of a Settings tab: `/app/settings?tab=<id>`. Connections too: the Channels page
 * (`/app/promote/promoteChannels`) is its own page in the Promote menu, with no Settings rail.
 */
export function settingsTabTarget(id: SMLSettingsTabId): SettingsTabTarget {
  return { route: SMLRoutes.settings, params: { tab: id } };
}
